import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const get = (mpi: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_IMMUNIZATION_REQUEST });

  return api.eligibility.immunization.get(mpi)
    .then((res: any) => {

      dispatch({
        type: types.GET_IMMUNIZATION_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_IMMUNIZATION_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

  